module.exports = __webpack_public_path__ + "img/oriental-mirrors.4f20a17b.jpeg";